// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type {
  B2CRenewalEmails,
  StudentVerificationView,
  StudentIdVerificationProvider,
  StudentVerificationStatus,
  B2CSubscription,
  GiftSubscription,
  GiftDonorSubscription,
  GiftReceiverSubscription,
  SubscriptionPayment,
  MonetaryAmount,
  SubscriptionStatus,
  TeamSubscription,
  CustomerAdminSubscriptionsForm,
} from "../schema";

export function serialize_CustomerAdminSubscriptionsForm(obj: CustomerAdminSubscriptionsForm): string {
  const serialized = ((value: {
    customerId: number;
    customerLanguageId: number;
    customerName: string;
    customerRandomCode: string;
    emailHistory: B2CRenewalEmails[];
    hasStudentSubscription: boolean;
    studentPreverification: StudentVerificationView | null;
    subscriptions: B2CSubscription[];
  }): unknown => {
    return {
      customerId: ((value: number): unknown => {
        return value;
      })(value["customerId"]),
      customerLanguageId: ((value: number): unknown => {
        return value;
      })(value["customerLanguageId"]),
      customerName: ((value: string): unknown => {
        return value;
      })(value["customerName"]),
      customerRandomCode: ((value: string): unknown => {
        return value;
      })(value["customerRandomCode"]),
      emailHistory: ((value: B2CRenewalEmails[]): unknown => {
        return value.map((value: { name: string; sendDate: DateTime<true>; type: string }): unknown => {
          return {
            name: ((value: string): unknown => {
              return value;
            })(value["name"]),
            sendDate: ((value: DateTime<true>): unknown => {
              return value.toMillis();
            })(value["sendDate"]),
            type: ((value: string): unknown => {
              return value;
            })(value["type"]),
          };
        });
      })(value["emailHistory"]),
      hasStudentSubscription: ((value: boolean): unknown => {
        return value;
      })(value["hasStudentSubscription"]),
      studentPreverification: ((
        value: {
          countryOfStudy: string;
          createdAt: DateTime<true>;
          fieldOfStudy: string | null;
          proof: string | null;
          provider: StudentIdVerificationProvider;
          status: StudentVerificationStatus;
          subscriptionId: number | null;
          verifiedAt: DateTime<true> | null;
        } | null,
      ): unknown => {
        if (value === null) {
          return null;
        }
        return {
          countryOfStudy: ((value: string): unknown => {
            return value;
          })(value["countryOfStudy"]),
          createdAt: ((value: DateTime<true>): unknown => {
            return value.toMillis();
          })(value["createdAt"]),
          fieldOfStudy: ((value: string | null): unknown => {
            if (value === null) {
              return null;
            }
            return value;
          })(value["fieldOfStudy"]),
          proof: ((value: string | null): unknown => {
            if (value === null) {
              return null;
            }
            return value;
          })(value["proof"]),
          provider: ((value: "UNIDAYS" | "UNIDAYS_PERK" | "SHEERID" | "MANUAL" | "UNKNOWN"): unknown => {
            return value;
          })(value["provider"]),
          status: ((value: "VERIFIED" | "EXPIRED" | "FAILED" | "IN_PROGRESS"): unknown => {
            return value;
          })(value["status"]),
          subscriptionId: ((value: number | null): unknown => {
            if (value === null) {
              return null;
            }
            return value;
          })(value["subscriptionId"]),
          verifiedAt: ((value: DateTime<true> | null): unknown => {
            if (value === null) {
              return null;
            }
            return value.toMillis();
          })(value["verifiedAt"]),
        };
      })(value["studentPreverification"]),
      subscriptions: ((value: B2CSubscription[]): unknown => {
        return value.map(
          (value: {
            actionStatus: string | null;
            customerId: number;
            editSubscriptionUrl: string;
            endDate: { year: number; month: number; day: number };
            giftSubscription: GiftSubscription | null;
            isCredited: boolean;
            isExpired: boolean;
            isLoss: boolean;
            isMobileSubscription: boolean;
            isPaid: boolean;
            isTeamSubscription: boolean;
            manualRenewalUrl: string;
            numberOfTransactions: number;
            product: string;
            productId: number;
            quantity: number;
            randomKey: string | null;
            startDate: { year: number; month: number; day: number };
            studentVerification: StudentVerificationView | null;
            subscriptionId: number;
            subscriptionPayment: SubscriptionPayment;
            subscriptionStatus: SubscriptionStatus;
            teamSubscription: TeamSubscription | null;
          }): unknown => {
            return {
              actionStatus: ((value: string | null): unknown => {
                if (value === null) {
                  return null;
                }
                return value;
              })(value["actionStatus"]),
              customerId: ((value: number): unknown => {
                return value;
              })(value["customerId"]),
              editSubscriptionUrl: ((value: string): unknown => {
                return value;
              })(value["editSubscriptionUrl"]),
              endDate: ((value: { year: number; month: number; day: number }): unknown => {
                return `${value.year.toFixed().padStart(4, "0")}-${value.month.toFixed().padStart(2, "0")}-${value.day.toFixed().padStart(2, "0")}`;
              })(value["endDate"]),
              giftSubscription: ((
                value: {
                  donorSubscription: GiftDonorSubscription | null;
                  giftReceiverSubscription: GiftReceiverSubscription | null;
                } | null,
              ): unknown => {
                if (value === null) {
                  return null;
                }
                return {
                  donorSubscription: ((
                    value: {
                      donorCustomerId: number;
                      donorSubscriptionId: number;
                    } | null,
                  ): unknown => {
                    if (value === null) {
                      return null;
                    }
                    return {
                      donorCustomerId: ((value: number): unknown => {
                        return value;
                      })(value["donorCustomerId"]),
                      donorSubscriptionId: ((value: number): unknown => {
                        return value;
                      })(value["donorSubscriptionId"]),
                    };
                  })(value["donorSubscription"]),
                  giftReceiverSubscription: ((
                    value: {
                      receiverCustomerId: number;
                      receiverSubscriptionId: number;
                    } | null,
                  ): unknown => {
                    if (value === null) {
                      return null;
                    }
                    return {
                      receiverCustomerId: ((value: number): unknown => {
                        return value;
                      })(value["receiverCustomerId"]),
                      receiverSubscriptionId: ((value: number): unknown => {
                        return value;
                      })(value["receiverSubscriptionId"]),
                    };
                  })(value["giftReceiverSubscription"]),
                };
              })(value["giftSubscription"]),
              isCredited: ((value: boolean): unknown => {
                return value;
              })(value["isCredited"]),
              isExpired: ((value: boolean): unknown => {
                return value;
              })(value["isExpired"]),
              isLoss: ((value: boolean): unknown => {
                return value;
              })(value["isLoss"]),
              isMobileSubscription: ((value: boolean): unknown => {
                return value;
              })(value["isMobileSubscription"]),
              isPaid: ((value: boolean): unknown => {
                return value;
              })(value["isPaid"]),
              isTeamSubscription: ((value: boolean): unknown => {
                return value;
              })(value["isTeamSubscription"]),
              manualRenewalUrl: ((value: string): unknown => {
                return value;
              })(value["manualRenewalUrl"]),
              numberOfTransactions: ((value: number): unknown => {
                return value;
              })(value["numberOfTransactions"]),
              product: ((value: string): unknown => {
                return value;
              })(value["product"]),
              productId: ((value: number): unknown => {
                return value;
              })(value["productId"]),
              quantity: ((value: number): unknown => {
                return value;
              })(value["quantity"]),
              randomKey: ((value: string | null): unknown => {
                if (value === null) {
                  return null;
                }
                return value;
              })(value["randomKey"]),
              startDate: ((value: { year: number; month: number; day: number }): unknown => {
                return `${value.year.toFixed().padStart(4, "0")}-${value.month.toFixed().padStart(2, "0")}-${value.day.toFixed().padStart(2, "0")}`;
              })(value["startDate"]),
              studentVerification: ((
                value: {
                  countryOfStudy: string;
                  createdAt: DateTime<true>;
                  fieldOfStudy: string | null;
                  proof: string | null;
                  provider: StudentIdVerificationProvider;
                  status: StudentVerificationStatus;
                  subscriptionId: number | null;
                  verifiedAt: DateTime<true> | null;
                } | null,
              ): unknown => {
                if (value === null) {
                  return null;
                }
                return {
                  countryOfStudy: ((value: string): unknown => {
                    return value;
                  })(value["countryOfStudy"]),
                  createdAt: ((value: DateTime<true>): unknown => {
                    return value.toMillis();
                  })(value["createdAt"]),
                  fieldOfStudy: ((value: string | null): unknown => {
                    if (value === null) {
                      return null;
                    }
                    return value;
                  })(value["fieldOfStudy"]),
                  proof: ((value: string | null): unknown => {
                    if (value === null) {
                      return null;
                    }
                    return value;
                  })(value["proof"]),
                  provider: ((value: "UNIDAYS" | "UNIDAYS_PERK" | "SHEERID" | "MANUAL" | "UNKNOWN"): unknown => {
                    return value;
                  })(value["provider"]),
                  status: ((value: "VERIFIED" | "EXPIRED" | "FAILED" | "IN_PROGRESS"): unknown => {
                    return value;
                  })(value["status"]),
                  subscriptionId: ((value: number | null): unknown => {
                    if (value === null) {
                      return null;
                    }
                    return value;
                  })(value["subscriptionId"]),
                  verifiedAt: ((value: DateTime<true> | null): unknown => {
                    if (value === null) {
                      return null;
                    }
                    return value.toMillis();
                  })(value["verifiedAt"]),
                };
              })(value["studentVerification"]),
              subscriptionId: ((value: number): unknown => {
                return value;
              })(value["subscriptionId"]),
              subscriptionPayment: ((value: { balance: MonetaryAmount; isMobilePayment: boolean; paymentType: string | null }): unknown => {
                return {
                  balance: ((value: { amount: number; currencyCode: string; displayValue: string }): unknown => {
                    return {
                      amount: ((value: number): unknown => {
                        return value;
                      })(value["amount"]),
                      currencyCode: ((value: string): unknown => {
                        return value;
                      })(value["currencyCode"]),
                      displayValue: ((value: string): unknown => {
                        return value;
                      })(value["displayValue"]),
                    };
                  })(value["balance"]),
                  isMobilePayment: ((value: boolean): unknown => {
                    return value;
                  })(value["isMobilePayment"]),
                  paymentType: ((value: string | null): unknown => {
                    if (value === null) {
                      return null;
                    }
                    return value;
                  })(value["paymentType"]),
                };
              })(value["subscriptionPayment"]),
              subscriptionStatus: ((value: "ACTIVE" | "STOP" | "CANCEL" | "RENEWED" | "RENEWALFAILED"): unknown => {
                return value;
              })(value["subscriptionStatus"]),
              teamSubscription: ((
                value: {
                  teamPortalCorporateId: number;
                  teamPortalUrl: string;
                  teamPortalUsername: string;
                } | null,
              ): unknown => {
                if (value === null) {
                  return null;
                }
                return {
                  teamPortalCorporateId: ((value: number): unknown => {
                    return value;
                  })(value["teamPortalCorporateId"]),
                  teamPortalUrl: ((value: string): unknown => {
                    return value;
                  })(value["teamPortalUrl"]),
                  teamPortalUsername: ((value: string): unknown => {
                    return value;
                  })(value["teamPortalUsername"]),
                };
              })(value["teamSubscription"]),
            };
          },
        );
      })(value["subscriptions"]),
    };
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_CustomerAdminSubscriptionsForm(str: string): ParserResult<CustomerAdminSubscriptionsForm> {
  return ((
    value: unknown,
  ): ParserResult<{
    customerId: number;
    customerLanguageId: number;
    customerName: string;
    customerRandomCode: string;
    emailHistory: B2CRenewalEmails[];
    hasStudentSubscription: boolean;
    studentPreverification: StudentVerificationView | null;
    subscriptions: B2CSubscription[];
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/CustomerAdminSubscriptionsForm]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/CustomerAdminSubscriptionsForm]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "customerId")) {
      return { success: false, reason: `[#/components/schemas/CustomerAdminSubscriptionsForm/customerId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'customerId'.` };
    }
    const parsed_customerId = ((): ParserResult<number> => {
      return ((value: unknown): ParserResult<number> => {
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/CustomerAdminSubscriptionsForm/customerId]: '${value}' expected to be of type number.` };
      })(value["customerId"]);
    })();
    if (!parsed_customerId.success) {
      return { success: false, reason: parsed_customerId.reason };
    }
    if (!hasProp(value, "customerLanguageId")) {
      return { success: false, reason: `[#/components/schemas/CustomerAdminSubscriptionsForm/customerLanguageId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'customerLanguageId'.` };
    }
    const parsed_customerLanguageId = ((): ParserResult<number> => {
      return ((value: unknown): ParserResult<number> => {
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/CustomerAdminSubscriptionsForm/customerLanguageId]: '${value}' expected to be of type number.` };
      })(value["customerLanguageId"]);
    })();
    if (!parsed_customerLanguageId.success) {
      return { success: false, reason: parsed_customerLanguageId.reason };
    }
    if (!hasProp(value, "customerName")) {
      return { success: false, reason: `[#/components/schemas/CustomerAdminSubscriptionsForm/customerName]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'customerName'.` };
    }
    const parsed_customerName = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/CustomerAdminSubscriptionsForm/customerName]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["customerName"]);
    })();
    if (!parsed_customerName.success) {
      return { success: false, reason: parsed_customerName.reason };
    }
    if (!hasProp(value, "customerRandomCode")) {
      return { success: false, reason: `[#/components/schemas/CustomerAdminSubscriptionsForm/customerRandomCode]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'customerRandomCode'.` };
    }
    const parsed_customerRandomCode = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/CustomerAdminSubscriptionsForm/customerRandomCode]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["customerRandomCode"]);
    })();
    if (!parsed_customerRandomCode.success) {
      return { success: false, reason: parsed_customerRandomCode.reason };
    }
    if (!hasProp(value, "emailHistory")) {
      return { success: false, reason: `[#/components/schemas/CustomerAdminSubscriptionsForm/emailHistory]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'emailHistory'.` };
    }
    const parsed_emailHistory = ((): ParserResult<B2CRenewalEmails[]> => {
      return ((value: unknown): ParserResult<B2CRenewalEmails[]> => {
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/CustomerAdminSubscriptionsForm/emailHistory]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<B2CRenewalEmails> => {
          return ((
            value: unknown,
          ): ParserResult<{
            name: string;
            sendDate: DateTime<true>;
            type: string;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/B2CRenewalEmails]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/B2CRenewalEmails]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "name")) {
              return { success: false, reason: `[#/components/schemas/B2CRenewalEmails/name]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'name'.` };
            }
            const parsed_name = ((): ParserResult<string> => {
              return ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/B2CRenewalEmails/name]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["name"]);
            })();
            if (!parsed_name.success) {
              return { success: false, reason: parsed_name.reason };
            }
            if (!hasProp(value, "sendDate")) {
              return { success: false, reason: `[#/components/schemas/B2CRenewalEmails/sendDate]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'sendDate'.` };
            }
            const parsed_sendDate = ((): ParserResult<DateTime<true>> => {
              return ((value: unknown): ParserResult<DateTime<true>> => {
                if (typeof value !== "number") {
                  return { success: false, reason: `[#/components/schemas/B2CRenewalEmails/sendDate]: '${value}' expected to be of type number.` };
                }
                const parsed = DateTime.fromMillis(value);
                if (!parsed.isValid) {
                  return { success: false, reason: `[#/components/schemas/B2CRenewalEmails/sendDate]: '${value}' expected to be valid DateTime.` };
                }
                return { success: true, value: parsed };
              })(value["sendDate"]);
            })();
            if (!parsed_sendDate.success) {
              return { success: false, reason: parsed_sendDate.reason };
            }
            if (!hasProp(value, "type")) {
              return { success: false, reason: `[#/components/schemas/B2CRenewalEmails/type]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'type'.` };
            }
            const parsed_type = ((): ParserResult<string> => {
              return ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/B2CRenewalEmails/type]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["type"]);
            })();
            if (!parsed_type.success) {
              return { success: false, reason: parsed_type.reason };
            }
            return { success: true, value: { name: parsed_name.value, sendDate: parsed_sendDate.value, type: parsed_type.value } };
          })(value);
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/CustomerAdminSubscriptionsForm/emailHistory]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["emailHistory"]);
    })();
    if (!parsed_emailHistory.success) {
      return { success: false, reason: parsed_emailHistory.reason };
    }
    if (!hasProp(value, "hasStudentSubscription")) {
      return { success: false, reason: `[#/components/schemas/CustomerAdminSubscriptionsForm/hasStudentSubscription]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'hasStudentSubscription'.` };
    }
    const parsed_hasStudentSubscription = ((): ParserResult<boolean> => {
      return ((value: unknown): ParserResult<boolean> => {
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/CustomerAdminSubscriptionsForm/hasStudentSubscription]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["hasStudentSubscription"]);
    })();
    if (!parsed_hasStudentSubscription.success) {
      return { success: false, reason: parsed_hasStudentSubscription.reason };
    }
    if (!hasProp(value, "studentPreverification")) {
      return { success: false, reason: `[#/components/schemas/CustomerAdminSubscriptionsForm/studentPreverification]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'studentPreverification'.` };
    }
    const parsed_studentPreverification = ((): ParserResult<StudentVerificationView | null> => {
      return ((value: unknown): ParserResult<StudentVerificationView | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        return ((
          value: unknown,
        ): ParserResult<{
          countryOfStudy: string;
          createdAt: DateTime<true>;
          fieldOfStudy: string | null;
          proof: string | null;
          provider: StudentIdVerificationProvider;
          status: StudentVerificationStatus;
          subscriptionId: number | null;
          verifiedAt: DateTime<true> | null;
        }> => {
          if (typeof value !== "object") {
            return { success: false, reason: `[#/components/schemas/StudentVerificationView]: '${value}' expected to be of type 'object'.` };
          }
          if (value === null) {
            return { success: false, reason: `[#/components/schemas/StudentVerificationView]: '${value}' expected to not be null.` };
          }
          if (!hasProp(value, "countryOfStudy")) {
            return { success: false, reason: `[#/components/schemas/StudentVerificationView/countryOfStudy]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'countryOfStudy'.` };
          }
          const parsed_countryOfStudy = ((): ParserResult<string> => {
            return ((value: unknown): ParserResult<string> => {
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/StudentVerificationView/countryOfStudy]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["countryOfStudy"]);
          })();
          if (!parsed_countryOfStudy.success) {
            return { success: false, reason: parsed_countryOfStudy.reason };
          }
          if (!hasProp(value, "createdAt")) {
            return { success: false, reason: `[#/components/schemas/StudentVerificationView/createdAt]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'createdAt'.` };
          }
          const parsed_createdAt = ((): ParserResult<DateTime<true>> => {
            return ((value: unknown): ParserResult<DateTime<true>> => {
              if (typeof value !== "number") {
                return { success: false, reason: `[#/components/schemas/StudentVerificationView/createdAt]: '${value}' expected to be of type number.` };
              }
              const parsed = DateTime.fromMillis(value);
              if (!parsed.isValid) {
                return { success: false, reason: `[#/components/schemas/StudentVerificationView/createdAt]: '${value}' expected to be valid DateTime.` };
              }
              return { success: true, value: parsed };
            })(value["createdAt"]);
          })();
          if (!parsed_createdAt.success) {
            return { success: false, reason: parsed_createdAt.reason };
          }
          if (!hasProp(value, "fieldOfStudy")) {
            return { success: false, reason: `[#/components/schemas/StudentVerificationView/fieldOfStudy]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'fieldOfStudy'.` };
          }
          const parsed_fieldOfStudy = ((): ParserResult<string | null> => {
            return ((value: unknown): ParserResult<string | null> => {
              if (value === null) {
                return { success: true, value: null };
              }
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/StudentVerificationView/fieldOfStudy]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["fieldOfStudy"]);
          })();
          if (!parsed_fieldOfStudy.success) {
            return { success: false, reason: parsed_fieldOfStudy.reason };
          }
          if (!hasProp(value, "proof")) {
            return { success: false, reason: `[#/components/schemas/StudentVerificationView/proof]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'proof'.` };
          }
          const parsed_proof = ((): ParserResult<string | null> => {
            return ((value: unknown): ParserResult<string | null> => {
              if (value === null) {
                return { success: true, value: null };
              }
              if (typeof value !== "string") {
                return { success: false, reason: `[#/components/schemas/StudentVerificationView/proof]: '${value}' expected to be of type string.` };
              }
              return { success: true, value: value };
            })(value["proof"]);
          })();
          if (!parsed_proof.success) {
            return { success: false, reason: parsed_proof.reason };
          }
          if (!hasProp(value, "provider")) {
            return { success: false, reason: `[#/components/schemas/StudentVerificationView/provider]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'provider'.` };
          }
          const parsed_provider = ((): ParserResult<StudentIdVerificationProvider> => {
            return ((value: unknown): ParserResult<StudentIdVerificationProvider> => {
              return ((value: unknown): ParserResult<"UNIDAYS" | "UNIDAYS_PERK" | "SHEERID" | "MANUAL" | "UNKNOWN"> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/StudentIdVerificationProvider]: '${value}' expected to be of type string.` };
                }
                switch (value) {
                  case "UNIDAYS":
                    return { success: true, value: "UNIDAYS" };
                  case "UNIDAYS_PERK":
                    return { success: true, value: "UNIDAYS_PERK" };
                  case "SHEERID":
                    return { success: true, value: "SHEERID" };
                  case "MANUAL":
                    return { success: true, value: "MANUAL" };
                  case "UNKNOWN":
                    return { success: true, value: "UNKNOWN" };
                  default:
                    return { success: false, reason: `[#/components/schemas/StudentIdVerificationProvider]: '${value}' expected to be enum, one of 'UNIDAYS, UNIDAYS_PERK, SHEERID, MANUAL, UNKNOWN'.` };
                }
              })(value);
            })(value["provider"]);
          })();
          if (!parsed_provider.success) {
            return { success: false, reason: parsed_provider.reason };
          }
          if (!hasProp(value, "status")) {
            return { success: false, reason: `[#/components/schemas/StudentVerificationView/status]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'status'.` };
          }
          const parsed_status = ((): ParserResult<StudentVerificationStatus> => {
            return ((value: unknown): ParserResult<StudentVerificationStatus> => {
              return ((value: unknown): ParserResult<"VERIFIED" | "EXPIRED" | "FAILED" | "IN_PROGRESS"> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/StudentVerificationStatus]: '${value}' expected to be of type string.` };
                }
                switch (value) {
                  case "VERIFIED":
                    return { success: true, value: "VERIFIED" };
                  case "EXPIRED":
                    return { success: true, value: "EXPIRED" };
                  case "FAILED":
                    return { success: true, value: "FAILED" };
                  case "IN_PROGRESS":
                    return { success: true, value: "IN_PROGRESS" };
                  default:
                    return { success: false, reason: `[#/components/schemas/StudentVerificationStatus]: '${value}' expected to be enum, one of 'VERIFIED, EXPIRED, FAILED, IN_PROGRESS'.` };
                }
              })(value);
            })(value["status"]);
          })();
          if (!parsed_status.success) {
            return { success: false, reason: parsed_status.reason };
          }
          if (!hasProp(value, "subscriptionId")) {
            return { success: false, reason: `[#/components/schemas/StudentVerificationView/subscriptionId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'subscriptionId'.` };
          }
          const parsed_subscriptionId = ((): ParserResult<number | null> => {
            return ((value: unknown): ParserResult<number | null> => {
              if (value === null) {
                return { success: true, value: null };
              }
              if (typeof value === "number") {
                return { success: true, value: value };
              }
              return { success: false, reason: `[#/components/schemas/StudentVerificationView/subscriptionId]: '${value}' expected to be of type number.` };
            })(value["subscriptionId"]);
          })();
          if (!parsed_subscriptionId.success) {
            return { success: false, reason: parsed_subscriptionId.reason };
          }
          if (!hasProp(value, "verifiedAt")) {
            return { success: false, reason: `[#/components/schemas/StudentVerificationView/verifiedAt]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'verifiedAt'.` };
          }
          const parsed_verifiedAt = ((): ParserResult<DateTime<true> | null> => {
            return ((value: unknown): ParserResult<DateTime<true> | null> => {
              if (value === null) {
                return { success: true, value: null };
              }
              if (typeof value !== "number") {
                return { success: false, reason: `[#/components/schemas/StudentVerificationView/verifiedAt]: '${value}' expected to be of type number.` };
              }
              const parsed = DateTime.fromMillis(value);
              if (!parsed.isValid) {
                return { success: false, reason: `[#/components/schemas/StudentVerificationView/verifiedAt]: '${value}' expected to be valid DateTime.` };
              }
              return { success: true, value: parsed };
            })(value["verifiedAt"]);
          })();
          if (!parsed_verifiedAt.success) {
            return { success: false, reason: parsed_verifiedAt.reason };
          }
          return {
            success: true,
            value: {
              countryOfStudy: parsed_countryOfStudy.value,
              createdAt: parsed_createdAt.value,
              fieldOfStudy: parsed_fieldOfStudy.value,
              proof: parsed_proof.value,
              provider: parsed_provider.value,
              status: parsed_status.value,
              subscriptionId: parsed_subscriptionId.value,
              verifiedAt: parsed_verifiedAt.value,
            },
          };
        })(value);
      })(value["studentPreverification"]);
    })();
    if (!parsed_studentPreverification.success) {
      return { success: false, reason: parsed_studentPreverification.reason };
    }
    if (!hasProp(value, "subscriptions")) {
      return { success: false, reason: `[#/components/schemas/CustomerAdminSubscriptionsForm/subscriptions]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'subscriptions'.` };
    }
    const parsed_subscriptions = ((): ParserResult<B2CSubscription[]> => {
      return ((value: unknown): ParserResult<B2CSubscription[]> => {
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/CustomerAdminSubscriptionsForm/subscriptions]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<B2CSubscription> => {
          return ((
            value: unknown,
          ): ParserResult<{
            actionStatus: string | null;
            customerId: number;
            editSubscriptionUrl: string;
            endDate: { year: number; month: number; day: number };
            giftSubscription: GiftSubscription | null;
            isCredited: boolean;
            isExpired: boolean;
            isLoss: boolean;
            isMobileSubscription: boolean;
            isPaid: boolean;
            isTeamSubscription: boolean;
            manualRenewalUrl: string;
            numberOfTransactions: number;
            product: string;
            productId: number;
            quantity: number;
            randomKey: string | null;
            startDate: { year: number; month: number; day: number };
            studentVerification: StudentVerificationView | null;
            subscriptionId: number;
            subscriptionPayment: SubscriptionPayment;
            subscriptionStatus: SubscriptionStatus;
            teamSubscription: TeamSubscription | null;
          }> => {
            if (typeof value !== "object") {
              return { success: false, reason: `[#/components/schemas/B2CSubscription]: '${value}' expected to be of type 'object'.` };
            }
            if (value === null) {
              return { success: false, reason: `[#/components/schemas/B2CSubscription]: '${value}' expected to not be null.` };
            }
            if (!hasProp(value, "actionStatus")) {
              return { success: false, reason: `[#/components/schemas/B2CSubscription/actionStatus]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'actionStatus'.` };
            }
            const parsed_actionStatus = ((): ParserResult<string | null> => {
              return ((value: unknown): ParserResult<string | null> => {
                if (value === null) {
                  return { success: true, value: null };
                }
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/B2CSubscription/actionStatus]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["actionStatus"]);
            })();
            if (!parsed_actionStatus.success) {
              return { success: false, reason: parsed_actionStatus.reason };
            }
            if (!hasProp(value, "customerId")) {
              return { success: false, reason: `[#/components/schemas/B2CSubscription/customerId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'customerId'.` };
            }
            const parsed_customerId = ((): ParserResult<number> => {
              return ((value: unknown): ParserResult<number> => {
                if (typeof value === "number") {
                  return { success: true, value: value };
                }
                return { success: false, reason: `[#/components/schemas/B2CSubscription/customerId]: '${value}' expected to be of type number.` };
              })(value["customerId"]);
            })();
            if (!parsed_customerId.success) {
              return { success: false, reason: parsed_customerId.reason };
            }
            if (!hasProp(value, "editSubscriptionUrl")) {
              return { success: false, reason: `[#/components/schemas/B2CSubscription/editSubscriptionUrl]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'editSubscriptionUrl'.` };
            }
            const parsed_editSubscriptionUrl = ((): ParserResult<string> => {
              return ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/B2CSubscription/editSubscriptionUrl]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["editSubscriptionUrl"]);
            })();
            if (!parsed_editSubscriptionUrl.success) {
              return { success: false, reason: parsed_editSubscriptionUrl.reason };
            }
            if (!hasProp(value, "endDate")) {
              return { success: false, reason: `[#/components/schemas/B2CSubscription/endDate]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'endDate'.` };
            }
            const parsed_endDate = ((): ParserResult<{ year: number; month: number; day: number }> => {
              return ((value: unknown): ParserResult<{ year: number; month: number; day: number }> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/B2CSubscription/endDate]: '${value}' expected to be of type string.` };
                }
                const parsed = DateTime.fromFormat(value, "yyyy-LL-dd");
                if (!parsed.isValid) {
                  return { success: false, reason: `[#/components/schemas/B2CSubscription/endDate]: '${value}' expected to be a valid date in format yyyy-LL-dd.` };
                }
                return { success: true, value: { year: parsed.year, month: parsed.month, day: parsed.day } };
              })(value["endDate"]);
            })();
            if (!parsed_endDate.success) {
              return { success: false, reason: parsed_endDate.reason };
            }
            if (!hasProp(value, "giftSubscription")) {
              return { success: false, reason: `[#/components/schemas/B2CSubscription/giftSubscription]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'giftSubscription'.` };
            }
            const parsed_giftSubscription = ((): ParserResult<GiftSubscription | null> => {
              return ((value: unknown): ParserResult<GiftSubscription | null> => {
                if (value === null) {
                  return { success: true, value: null };
                }
                return ((
                  value: unknown,
                ): ParserResult<{
                  donorSubscription: GiftDonorSubscription | null;
                  giftReceiverSubscription: GiftReceiverSubscription | null;
                }> => {
                  if (typeof value !== "object") {
                    return { success: false, reason: `[#/components/schemas/GiftSubscription]: '${value}' expected to be of type 'object'.` };
                  }
                  if (value === null) {
                    return { success: false, reason: `[#/components/schemas/GiftSubscription]: '${value}' expected to not be null.` };
                  }
                  if (!hasProp(value, "donorSubscription")) {
                    return { success: false, reason: `[#/components/schemas/GiftSubscription/donorSubscription]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'donorSubscription'.` };
                  }
                  const parsed_donorSubscription = ((): ParserResult<GiftDonorSubscription | null> => {
                    return ((value: unknown): ParserResult<GiftDonorSubscription | null> => {
                      if (value === null) {
                        return { success: true, value: null };
                      }
                      return ((
                        value: unknown,
                      ): ParserResult<{
                        donorCustomerId: number;
                        donorSubscriptionId: number;
                      }> => {
                        if (typeof value !== "object") {
                          return { success: false, reason: `[#/components/schemas/GiftDonorSubscription]: '${value}' expected to be of type 'object'.` };
                        }
                        if (value === null) {
                          return { success: false, reason: `[#/components/schemas/GiftDonorSubscription]: '${value}' expected to not be null.` };
                        }
                        if (!hasProp(value, "donorCustomerId")) {
                          return { success: false, reason: `[#/components/schemas/GiftDonorSubscription/donorCustomerId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'donorCustomerId'.` };
                        }
                        const parsed_donorCustomerId = ((): ParserResult<number> => {
                          return ((value: unknown): ParserResult<number> => {
                            if (typeof value === "number") {
                              return { success: true, value: value };
                            }
                            return { success: false, reason: `[#/components/schemas/GiftDonorSubscription/donorCustomerId]: '${value}' expected to be of type number.` };
                          })(value["donorCustomerId"]);
                        })();
                        if (!parsed_donorCustomerId.success) {
                          return { success: false, reason: parsed_donorCustomerId.reason };
                        }
                        if (!hasProp(value, "donorSubscriptionId")) {
                          return { success: false, reason: `[#/components/schemas/GiftDonorSubscription/donorSubscriptionId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'donorSubscriptionId'.` };
                        }
                        const parsed_donorSubscriptionId = ((): ParserResult<number> => {
                          return ((value: unknown): ParserResult<number> => {
                            if (typeof value === "number") {
                              return { success: true, value: value };
                            }
                            return { success: false, reason: `[#/components/schemas/GiftDonorSubscription/donorSubscriptionId]: '${value}' expected to be of type number.` };
                          })(value["donorSubscriptionId"]);
                        })();
                        if (!parsed_donorSubscriptionId.success) {
                          return { success: false, reason: parsed_donorSubscriptionId.reason };
                        }
                        return { success: true, value: { donorCustomerId: parsed_donorCustomerId.value, donorSubscriptionId: parsed_donorSubscriptionId.value } };
                      })(value);
                    })(value["donorSubscription"]);
                  })();
                  if (!parsed_donorSubscription.success) {
                    return { success: false, reason: parsed_donorSubscription.reason };
                  }
                  if (!hasProp(value, "giftReceiverSubscription")) {
                    return { success: false, reason: `[#/components/schemas/GiftSubscription/giftReceiverSubscription]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'giftReceiverSubscription'.` };
                  }
                  const parsed_giftReceiverSubscription = ((): ParserResult<GiftReceiverSubscription | null> => {
                    return ((value: unknown): ParserResult<GiftReceiverSubscription | null> => {
                      if (value === null) {
                        return { success: true, value: null };
                      }
                      return ((
                        value: unknown,
                      ): ParserResult<{
                        receiverCustomerId: number;
                        receiverSubscriptionId: number;
                      }> => {
                        if (typeof value !== "object") {
                          return { success: false, reason: `[#/components/schemas/GiftReceiverSubscription]: '${value}' expected to be of type 'object'.` };
                        }
                        if (value === null) {
                          return { success: false, reason: `[#/components/schemas/GiftReceiverSubscription]: '${value}' expected to not be null.` };
                        }
                        if (!hasProp(value, "receiverCustomerId")) {
                          return { success: false, reason: `[#/components/schemas/GiftReceiverSubscription/receiverCustomerId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'receiverCustomerId'.` };
                        }
                        const parsed_receiverCustomerId = ((): ParserResult<number> => {
                          return ((value: unknown): ParserResult<number> => {
                            if (typeof value === "number") {
                              return { success: true, value: value };
                            }
                            return { success: false, reason: `[#/components/schemas/GiftReceiverSubscription/receiverCustomerId]: '${value}' expected to be of type number.` };
                          })(value["receiverCustomerId"]);
                        })();
                        if (!parsed_receiverCustomerId.success) {
                          return { success: false, reason: parsed_receiverCustomerId.reason };
                        }
                        if (!hasProp(value, "receiverSubscriptionId")) {
                          return { success: false, reason: `[#/components/schemas/GiftReceiverSubscription/receiverSubscriptionId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'receiverSubscriptionId'.` };
                        }
                        const parsed_receiverSubscriptionId = ((): ParserResult<number> => {
                          return ((value: unknown): ParserResult<number> => {
                            if (typeof value === "number") {
                              return { success: true, value: value };
                            }
                            return { success: false, reason: `[#/components/schemas/GiftReceiverSubscription/receiverSubscriptionId]: '${value}' expected to be of type number.` };
                          })(value["receiverSubscriptionId"]);
                        })();
                        if (!parsed_receiverSubscriptionId.success) {
                          return { success: false, reason: parsed_receiverSubscriptionId.reason };
                        }
                        return { success: true, value: { receiverCustomerId: parsed_receiverCustomerId.value, receiverSubscriptionId: parsed_receiverSubscriptionId.value } };
                      })(value);
                    })(value["giftReceiverSubscription"]);
                  })();
                  if (!parsed_giftReceiverSubscription.success) {
                    return { success: false, reason: parsed_giftReceiverSubscription.reason };
                  }
                  return { success: true, value: { donorSubscription: parsed_donorSubscription.value, giftReceiverSubscription: parsed_giftReceiverSubscription.value } };
                })(value);
              })(value["giftSubscription"]);
            })();
            if (!parsed_giftSubscription.success) {
              return { success: false, reason: parsed_giftSubscription.reason };
            }
            if (!hasProp(value, "isCredited")) {
              return { success: false, reason: `[#/components/schemas/B2CSubscription/isCredited]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'isCredited'.` };
            }
            const parsed_isCredited = ((): ParserResult<boolean> => {
              return ((value: unknown): ParserResult<boolean> => {
                if (typeof value !== "boolean") {
                  return { success: false, reason: `[#/components/schemas/B2CSubscription/isCredited]: '${value}' expected to be of type boolean.` };
                }
                return { success: true, value: value };
              })(value["isCredited"]);
            })();
            if (!parsed_isCredited.success) {
              return { success: false, reason: parsed_isCredited.reason };
            }
            if (!hasProp(value, "isExpired")) {
              return { success: false, reason: `[#/components/schemas/B2CSubscription/isExpired]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'isExpired'.` };
            }
            const parsed_isExpired = ((): ParserResult<boolean> => {
              return ((value: unknown): ParserResult<boolean> => {
                if (typeof value !== "boolean") {
                  return { success: false, reason: `[#/components/schemas/B2CSubscription/isExpired]: '${value}' expected to be of type boolean.` };
                }
                return { success: true, value: value };
              })(value["isExpired"]);
            })();
            if (!parsed_isExpired.success) {
              return { success: false, reason: parsed_isExpired.reason };
            }
            if (!hasProp(value, "isLoss")) {
              return { success: false, reason: `[#/components/schemas/B2CSubscription/isLoss]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'isLoss'.` };
            }
            const parsed_isLoss = ((): ParserResult<boolean> => {
              return ((value: unknown): ParserResult<boolean> => {
                if (typeof value !== "boolean") {
                  return { success: false, reason: `[#/components/schemas/B2CSubscription/isLoss]: '${value}' expected to be of type boolean.` };
                }
                return { success: true, value: value };
              })(value["isLoss"]);
            })();
            if (!parsed_isLoss.success) {
              return { success: false, reason: parsed_isLoss.reason };
            }
            if (!hasProp(value, "isMobileSubscription")) {
              return { success: false, reason: `[#/components/schemas/B2CSubscription/isMobileSubscription]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'isMobileSubscription'.` };
            }
            const parsed_isMobileSubscription = ((): ParserResult<boolean> => {
              return ((value: unknown): ParserResult<boolean> => {
                if (typeof value !== "boolean") {
                  return { success: false, reason: `[#/components/schemas/B2CSubscription/isMobileSubscription]: '${value}' expected to be of type boolean.` };
                }
                return { success: true, value: value };
              })(value["isMobileSubscription"]);
            })();
            if (!parsed_isMobileSubscription.success) {
              return { success: false, reason: parsed_isMobileSubscription.reason };
            }
            if (!hasProp(value, "isPaid")) {
              return { success: false, reason: `[#/components/schemas/B2CSubscription/isPaid]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'isPaid'.` };
            }
            const parsed_isPaid = ((): ParserResult<boolean> => {
              return ((value: unknown): ParserResult<boolean> => {
                if (typeof value !== "boolean") {
                  return { success: false, reason: `[#/components/schemas/B2CSubscription/isPaid]: '${value}' expected to be of type boolean.` };
                }
                return { success: true, value: value };
              })(value["isPaid"]);
            })();
            if (!parsed_isPaid.success) {
              return { success: false, reason: parsed_isPaid.reason };
            }
            if (!hasProp(value, "isTeamSubscription")) {
              return { success: false, reason: `[#/components/schemas/B2CSubscription/isTeamSubscription]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'isTeamSubscription'.` };
            }
            const parsed_isTeamSubscription = ((): ParserResult<boolean> => {
              return ((value: unknown): ParserResult<boolean> => {
                if (typeof value !== "boolean") {
                  return { success: false, reason: `[#/components/schemas/B2CSubscription/isTeamSubscription]: '${value}' expected to be of type boolean.` };
                }
                return { success: true, value: value };
              })(value["isTeamSubscription"]);
            })();
            if (!parsed_isTeamSubscription.success) {
              return { success: false, reason: parsed_isTeamSubscription.reason };
            }
            if (!hasProp(value, "manualRenewalUrl")) {
              return { success: false, reason: `[#/components/schemas/B2CSubscription/manualRenewalUrl]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'manualRenewalUrl'.` };
            }
            const parsed_manualRenewalUrl = ((): ParserResult<string> => {
              return ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/B2CSubscription/manualRenewalUrl]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["manualRenewalUrl"]);
            })();
            if (!parsed_manualRenewalUrl.success) {
              return { success: false, reason: parsed_manualRenewalUrl.reason };
            }
            if (!hasProp(value, "numberOfTransactions")) {
              return { success: false, reason: `[#/components/schemas/B2CSubscription/numberOfTransactions]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'numberOfTransactions'.` };
            }
            const parsed_numberOfTransactions = ((): ParserResult<number> => {
              return ((value: unknown): ParserResult<number> => {
                if (typeof value === "number") {
                  return { success: true, value: value };
                }
                return { success: false, reason: `[#/components/schemas/B2CSubscription/numberOfTransactions]: '${value}' expected to be of type number.` };
              })(value["numberOfTransactions"]);
            })();
            if (!parsed_numberOfTransactions.success) {
              return { success: false, reason: parsed_numberOfTransactions.reason };
            }
            if (!hasProp(value, "product")) {
              return { success: false, reason: `[#/components/schemas/B2CSubscription/product]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'product'.` };
            }
            const parsed_product = ((): ParserResult<string> => {
              return ((value: unknown): ParserResult<string> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/B2CSubscription/product]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["product"]);
            })();
            if (!parsed_product.success) {
              return { success: false, reason: parsed_product.reason };
            }
            if (!hasProp(value, "productId")) {
              return { success: false, reason: `[#/components/schemas/B2CSubscription/productId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'productId'.` };
            }
            const parsed_productId = ((): ParserResult<number> => {
              return ((value: unknown): ParserResult<number> => {
                if (typeof value === "number") {
                  return { success: true, value: value };
                }
                return { success: false, reason: `[#/components/schemas/B2CSubscription/productId]: '${value}' expected to be of type number.` };
              })(value["productId"]);
            })();
            if (!parsed_productId.success) {
              return { success: false, reason: parsed_productId.reason };
            }
            if (!hasProp(value, "quantity")) {
              return { success: false, reason: `[#/components/schemas/B2CSubscription/quantity]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'quantity'.` };
            }
            const parsed_quantity = ((): ParserResult<number> => {
              return ((value: unknown): ParserResult<number> => {
                if (typeof value === "number") {
                  return { success: true, value: value };
                }
                return { success: false, reason: `[#/components/schemas/B2CSubscription/quantity]: '${value}' expected to be of type number.` };
              })(value["quantity"]);
            })();
            if (!parsed_quantity.success) {
              return { success: false, reason: parsed_quantity.reason };
            }
            if (!hasProp(value, "randomKey")) {
              return { success: false, reason: `[#/components/schemas/B2CSubscription/randomKey]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'randomKey'.` };
            }
            const parsed_randomKey = ((): ParserResult<string | null> => {
              return ((value: unknown): ParserResult<string | null> => {
                if (value === null) {
                  return { success: true, value: null };
                }
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/B2CSubscription/randomKey]: '${value}' expected to be of type string.` };
                }
                return { success: true, value: value };
              })(value["randomKey"]);
            })();
            if (!parsed_randomKey.success) {
              return { success: false, reason: parsed_randomKey.reason };
            }
            if (!hasProp(value, "startDate")) {
              return { success: false, reason: `[#/components/schemas/B2CSubscription/startDate]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'startDate'.` };
            }
            const parsed_startDate = ((): ParserResult<{ year: number; month: number; day: number }> => {
              return ((value: unknown): ParserResult<{ year: number; month: number; day: number }> => {
                if (typeof value !== "string") {
                  return { success: false, reason: `[#/components/schemas/B2CSubscription/startDate]: '${value}' expected to be of type string.` };
                }
                const parsed = DateTime.fromFormat(value, "yyyy-LL-dd");
                if (!parsed.isValid) {
                  return { success: false, reason: `[#/components/schemas/B2CSubscription/startDate]: '${value}' expected to be a valid date in format yyyy-LL-dd.` };
                }
                return { success: true, value: { year: parsed.year, month: parsed.month, day: parsed.day } };
              })(value["startDate"]);
            })();
            if (!parsed_startDate.success) {
              return { success: false, reason: parsed_startDate.reason };
            }
            if (!hasProp(value, "studentVerification")) {
              return { success: false, reason: `[#/components/schemas/B2CSubscription/studentVerification]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'studentVerification'.` };
            }
            const parsed_studentVerification = ((): ParserResult<StudentVerificationView | null> => {
              return ((value: unknown): ParserResult<StudentVerificationView | null> => {
                if (value === null) {
                  return { success: true, value: null };
                }
                return ((
                  value: unknown,
                ): ParserResult<{
                  countryOfStudy: string;
                  createdAt: DateTime<true>;
                  fieldOfStudy: string | null;
                  proof: string | null;
                  provider: StudentIdVerificationProvider;
                  status: StudentVerificationStatus;
                  subscriptionId: number | null;
                  verifiedAt: DateTime<true> | null;
                }> => {
                  if (typeof value !== "object") {
                    return { success: false, reason: `[#/components/schemas/StudentVerificationView]: '${value}' expected to be of type 'object'.` };
                  }
                  if (value === null) {
                    return { success: false, reason: `[#/components/schemas/StudentVerificationView]: '${value}' expected to not be null.` };
                  }
                  if (!hasProp(value, "countryOfStudy")) {
                    return { success: false, reason: `[#/components/schemas/StudentVerificationView/countryOfStudy]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'countryOfStudy'.` };
                  }
                  const parsed_countryOfStudy = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/StudentVerificationView/countryOfStudy]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["countryOfStudy"]);
                  })();
                  if (!parsed_countryOfStudy.success) {
                    return { success: false, reason: parsed_countryOfStudy.reason };
                  }
                  if (!hasProp(value, "createdAt")) {
                    return { success: false, reason: `[#/components/schemas/StudentVerificationView/createdAt]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'createdAt'.` };
                  }
                  const parsed_createdAt = ((): ParserResult<DateTime<true>> => {
                    return ((value: unknown): ParserResult<DateTime<true>> => {
                      if (typeof value !== "number") {
                        return { success: false, reason: `[#/components/schemas/StudentVerificationView/createdAt]: '${value}' expected to be of type number.` };
                      }
                      const parsed = DateTime.fromMillis(value);
                      if (!parsed.isValid) {
                        return { success: false, reason: `[#/components/schemas/StudentVerificationView/createdAt]: '${value}' expected to be valid DateTime.` };
                      }
                      return { success: true, value: parsed };
                    })(value["createdAt"]);
                  })();
                  if (!parsed_createdAt.success) {
                    return { success: false, reason: parsed_createdAt.reason };
                  }
                  if (!hasProp(value, "fieldOfStudy")) {
                    return { success: false, reason: `[#/components/schemas/StudentVerificationView/fieldOfStudy]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'fieldOfStudy'.` };
                  }
                  const parsed_fieldOfStudy = ((): ParserResult<string | null> => {
                    return ((value: unknown): ParserResult<string | null> => {
                      if (value === null) {
                        return { success: true, value: null };
                      }
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/StudentVerificationView/fieldOfStudy]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["fieldOfStudy"]);
                  })();
                  if (!parsed_fieldOfStudy.success) {
                    return { success: false, reason: parsed_fieldOfStudy.reason };
                  }
                  if (!hasProp(value, "proof")) {
                    return { success: false, reason: `[#/components/schemas/StudentVerificationView/proof]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'proof'.` };
                  }
                  const parsed_proof = ((): ParserResult<string | null> => {
                    return ((value: unknown): ParserResult<string | null> => {
                      if (value === null) {
                        return { success: true, value: null };
                      }
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/StudentVerificationView/proof]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["proof"]);
                  })();
                  if (!parsed_proof.success) {
                    return { success: false, reason: parsed_proof.reason };
                  }
                  if (!hasProp(value, "provider")) {
                    return { success: false, reason: `[#/components/schemas/StudentVerificationView/provider]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'provider'.` };
                  }
                  const parsed_provider = ((): ParserResult<StudentIdVerificationProvider> => {
                    return ((value: unknown): ParserResult<StudentIdVerificationProvider> => {
                      return ((value: unknown): ParserResult<"UNIDAYS" | "UNIDAYS_PERK" | "SHEERID" | "MANUAL" | "UNKNOWN"> => {
                        if (typeof value !== "string") {
                          return { success: false, reason: `[#/components/schemas/StudentIdVerificationProvider]: '${value}' expected to be of type string.` };
                        }
                        switch (value) {
                          case "UNIDAYS":
                            return { success: true, value: "UNIDAYS" };
                          case "UNIDAYS_PERK":
                            return { success: true, value: "UNIDAYS_PERK" };
                          case "SHEERID":
                            return { success: true, value: "SHEERID" };
                          case "MANUAL":
                            return { success: true, value: "MANUAL" };
                          case "UNKNOWN":
                            return { success: true, value: "UNKNOWN" };
                          default:
                            return { success: false, reason: `[#/components/schemas/StudentIdVerificationProvider]: '${value}' expected to be enum, one of 'UNIDAYS, UNIDAYS_PERK, SHEERID, MANUAL, UNKNOWN'.` };
                        }
                      })(value);
                    })(value["provider"]);
                  })();
                  if (!parsed_provider.success) {
                    return { success: false, reason: parsed_provider.reason };
                  }
                  if (!hasProp(value, "status")) {
                    return { success: false, reason: `[#/components/schemas/StudentVerificationView/status]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'status'.` };
                  }
                  const parsed_status = ((): ParserResult<StudentVerificationStatus> => {
                    return ((value: unknown): ParserResult<StudentVerificationStatus> => {
                      return ((value: unknown): ParserResult<"VERIFIED" | "EXPIRED" | "FAILED" | "IN_PROGRESS"> => {
                        if (typeof value !== "string") {
                          return { success: false, reason: `[#/components/schemas/StudentVerificationStatus]: '${value}' expected to be of type string.` };
                        }
                        switch (value) {
                          case "VERIFIED":
                            return { success: true, value: "VERIFIED" };
                          case "EXPIRED":
                            return { success: true, value: "EXPIRED" };
                          case "FAILED":
                            return { success: true, value: "FAILED" };
                          case "IN_PROGRESS":
                            return { success: true, value: "IN_PROGRESS" };
                          default:
                            return { success: false, reason: `[#/components/schemas/StudentVerificationStatus]: '${value}' expected to be enum, one of 'VERIFIED, EXPIRED, FAILED, IN_PROGRESS'.` };
                        }
                      })(value);
                    })(value["status"]);
                  })();
                  if (!parsed_status.success) {
                    return { success: false, reason: parsed_status.reason };
                  }
                  if (!hasProp(value, "subscriptionId")) {
                    return { success: false, reason: `[#/components/schemas/StudentVerificationView/subscriptionId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'subscriptionId'.` };
                  }
                  const parsed_subscriptionId = ((): ParserResult<number | null> => {
                    return ((value: unknown): ParserResult<number | null> => {
                      if (value === null) {
                        return { success: true, value: null };
                      }
                      if (typeof value === "number") {
                        return { success: true, value: value };
                      }
                      return { success: false, reason: `[#/components/schemas/StudentVerificationView/subscriptionId]: '${value}' expected to be of type number.` };
                    })(value["subscriptionId"]);
                  })();
                  if (!parsed_subscriptionId.success) {
                    return { success: false, reason: parsed_subscriptionId.reason };
                  }
                  if (!hasProp(value, "verifiedAt")) {
                    return { success: false, reason: `[#/components/schemas/StudentVerificationView/verifiedAt]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'verifiedAt'.` };
                  }
                  const parsed_verifiedAt = ((): ParserResult<DateTime<true> | null> => {
                    return ((value: unknown): ParserResult<DateTime<true> | null> => {
                      if (value === null) {
                        return { success: true, value: null };
                      }
                      if (typeof value !== "number") {
                        return { success: false, reason: `[#/components/schemas/StudentVerificationView/verifiedAt]: '${value}' expected to be of type number.` };
                      }
                      const parsed = DateTime.fromMillis(value);
                      if (!parsed.isValid) {
                        return { success: false, reason: `[#/components/schemas/StudentVerificationView/verifiedAt]: '${value}' expected to be valid DateTime.` };
                      }
                      return { success: true, value: parsed };
                    })(value["verifiedAt"]);
                  })();
                  if (!parsed_verifiedAt.success) {
                    return { success: false, reason: parsed_verifiedAt.reason };
                  }
                  return {
                    success: true,
                    value: {
                      countryOfStudy: parsed_countryOfStudy.value,
                      createdAt: parsed_createdAt.value,
                      fieldOfStudy: parsed_fieldOfStudy.value,
                      proof: parsed_proof.value,
                      provider: parsed_provider.value,
                      status: parsed_status.value,
                      subscriptionId: parsed_subscriptionId.value,
                      verifiedAt: parsed_verifiedAt.value,
                    },
                  };
                })(value);
              })(value["studentVerification"]);
            })();
            if (!parsed_studentVerification.success) {
              return { success: false, reason: parsed_studentVerification.reason };
            }
            if (!hasProp(value, "subscriptionId")) {
              return { success: false, reason: `[#/components/schemas/B2CSubscription/subscriptionId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'subscriptionId'.` };
            }
            const parsed_subscriptionId = ((): ParserResult<number> => {
              return ((value: unknown): ParserResult<number> => {
                if (typeof value === "number") {
                  return { success: true, value: value };
                }
                return { success: false, reason: `[#/components/schemas/B2CSubscription/subscriptionId]: '${value}' expected to be of type number.` };
              })(value["subscriptionId"]);
            })();
            if (!parsed_subscriptionId.success) {
              return { success: false, reason: parsed_subscriptionId.reason };
            }
            if (!hasProp(value, "subscriptionPayment")) {
              return { success: false, reason: `[#/components/schemas/B2CSubscription/subscriptionPayment]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'subscriptionPayment'.` };
            }
            const parsed_subscriptionPayment = ((): ParserResult<SubscriptionPayment> => {
              return ((value: unknown): ParserResult<SubscriptionPayment> => {
                return ((
                  value: unknown,
                ): ParserResult<{
                  balance: MonetaryAmount;
                  isMobilePayment: boolean;
                  paymentType: string | null;
                }> => {
                  if (typeof value !== "object") {
                    return { success: false, reason: `[#/components/schemas/SubscriptionPayment]: '${value}' expected to be of type 'object'.` };
                  }
                  if (value === null) {
                    return { success: false, reason: `[#/components/schemas/SubscriptionPayment]: '${value}' expected to not be null.` };
                  }
                  if (!hasProp(value, "balance")) {
                    return { success: false, reason: `[#/components/schemas/SubscriptionPayment/balance]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'balance'.` };
                  }
                  const parsed_balance = ((): ParserResult<MonetaryAmount> => {
                    return ((value: unknown): ParserResult<MonetaryAmount> => {
                      return ((
                        value: unknown,
                      ): ParserResult<{
                        amount: number;
                        currencyCode: string;
                        displayValue: string;
                      }> => {
                        if (typeof value !== "object") {
                          return { success: false, reason: `[#/components/schemas/MonetaryAmount]: '${value}' expected to be of type 'object'.` };
                        }
                        if (value === null) {
                          return { success: false, reason: `[#/components/schemas/MonetaryAmount]: '${value}' expected to not be null.` };
                        }
                        if (!hasProp(value, "amount")) {
                          return { success: false, reason: `[#/components/schemas/MonetaryAmount/amount]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'amount'.` };
                        }
                        const parsed_amount = ((): ParserResult<number> => {
                          return ((value: unknown): ParserResult<number> => {
                            if (typeof value === "number") {
                              return { success: true, value: value };
                            }
                            if (typeof value === "bigint") {
                              return { success: true, value: Number(value) };
                            }
                            return { success: false, reason: `[#/components/schemas/MonetaryAmount/amount]: '${value}' expected to be of type number or bigint.` };
                          })(value["amount"]);
                        })();
                        if (!parsed_amount.success) {
                          return { success: false, reason: parsed_amount.reason };
                        }
                        if (!hasProp(value, "currencyCode")) {
                          return { success: false, reason: `[#/components/schemas/MonetaryAmount/currencyCode]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'currencyCode'.` };
                        }
                        const parsed_currencyCode = ((): ParserResult<string> => {
                          return ((value: unknown): ParserResult<string> => {
                            if (typeof value !== "string") {
                              return { success: false, reason: `[#/components/schemas/MonetaryAmount/currencyCode]: '${value}' expected to be of type string.` };
                            }
                            return { success: true, value: value };
                          })(value["currencyCode"]);
                        })();
                        if (!parsed_currencyCode.success) {
                          return { success: false, reason: parsed_currencyCode.reason };
                        }
                        if (!hasProp(value, "displayValue")) {
                          return { success: false, reason: `[#/components/schemas/MonetaryAmount/displayValue]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'displayValue'.` };
                        }
                        const parsed_displayValue = ((): ParserResult<string> => {
                          return ((value: unknown): ParserResult<string> => {
                            if (typeof value !== "string") {
                              return { success: false, reason: `[#/components/schemas/MonetaryAmount/displayValue]: '${value}' expected to be of type string.` };
                            }
                            return { success: true, value: value };
                          })(value["displayValue"]);
                        })();
                        if (!parsed_displayValue.success) {
                          return { success: false, reason: parsed_displayValue.reason };
                        }
                        return { success: true, value: { amount: parsed_amount.value, currencyCode: parsed_currencyCode.value, displayValue: parsed_displayValue.value } };
                      })(value);
                    })(value["balance"]);
                  })();
                  if (!parsed_balance.success) {
                    return { success: false, reason: parsed_balance.reason };
                  }
                  if (!hasProp(value, "isMobilePayment")) {
                    return { success: false, reason: `[#/components/schemas/SubscriptionPayment/isMobilePayment]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'isMobilePayment'.` };
                  }
                  const parsed_isMobilePayment = ((): ParserResult<boolean> => {
                    return ((value: unknown): ParserResult<boolean> => {
                      if (typeof value !== "boolean") {
                        return { success: false, reason: `[#/components/schemas/SubscriptionPayment/isMobilePayment]: '${value}' expected to be of type boolean.` };
                      }
                      return { success: true, value: value };
                    })(value["isMobilePayment"]);
                  })();
                  if (!parsed_isMobilePayment.success) {
                    return { success: false, reason: parsed_isMobilePayment.reason };
                  }
                  if (!hasProp(value, "paymentType")) {
                    return { success: false, reason: `[#/components/schemas/SubscriptionPayment/paymentType]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'paymentType'.` };
                  }
                  const parsed_paymentType = ((): ParserResult<string | null> => {
                    return ((value: unknown): ParserResult<string | null> => {
                      if (value === null) {
                        return { success: true, value: null };
                      }
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/SubscriptionPayment/paymentType]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["paymentType"]);
                  })();
                  if (!parsed_paymentType.success) {
                    return { success: false, reason: parsed_paymentType.reason };
                  }
                  return { success: true, value: { balance: parsed_balance.value, isMobilePayment: parsed_isMobilePayment.value, paymentType: parsed_paymentType.value } };
                })(value);
              })(value["subscriptionPayment"]);
            })();
            if (!parsed_subscriptionPayment.success) {
              return { success: false, reason: parsed_subscriptionPayment.reason };
            }
            if (!hasProp(value, "subscriptionStatus")) {
              return { success: false, reason: `[#/components/schemas/B2CSubscription/subscriptionStatus]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'subscriptionStatus'.` };
            }
            const parsed_subscriptionStatus = ((): ParserResult<SubscriptionStatus> => {
              return ((value: unknown): ParserResult<SubscriptionStatus> => {
                return ((value: unknown): ParserResult<"ACTIVE" | "STOP" | "CANCEL" | "RENEWED" | "RENEWALFAILED"> => {
                  if (typeof value !== "string") {
                    return { success: false, reason: `[#/components/schemas/SubscriptionStatus]: '${value}' expected to be of type string.` };
                  }
                  switch (value) {
                    case "ACTIVE":
                      return { success: true, value: "ACTIVE" };
                    case "STOP":
                      return { success: true, value: "STOP" };
                    case "CANCEL":
                      return { success: true, value: "CANCEL" };
                    case "RENEWED":
                      return { success: true, value: "RENEWED" };
                    case "RENEWALFAILED":
                      return { success: true, value: "RENEWALFAILED" };
                    default:
                      return { success: false, reason: `[#/components/schemas/SubscriptionStatus]: '${value}' expected to be enum, one of 'ACTIVE, STOP, CANCEL, RENEWED, RENEWALFAILED'.` };
                  }
                })(value);
              })(value["subscriptionStatus"]);
            })();
            if (!parsed_subscriptionStatus.success) {
              return { success: false, reason: parsed_subscriptionStatus.reason };
            }
            if (!hasProp(value, "teamSubscription")) {
              return { success: false, reason: `[#/components/schemas/B2CSubscription/teamSubscription]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'teamSubscription'.` };
            }
            const parsed_teamSubscription = ((): ParserResult<TeamSubscription | null> => {
              return ((value: unknown): ParserResult<TeamSubscription | null> => {
                if (value === null) {
                  return { success: true, value: null };
                }
                return ((
                  value: unknown,
                ): ParserResult<{
                  teamPortalCorporateId: number;
                  teamPortalUrl: string;
                  teamPortalUsername: string;
                }> => {
                  if (typeof value !== "object") {
                    return { success: false, reason: `[#/components/schemas/TeamSubscription]: '${value}' expected to be of type 'object'.` };
                  }
                  if (value === null) {
                    return { success: false, reason: `[#/components/schemas/TeamSubscription]: '${value}' expected to not be null.` };
                  }
                  if (!hasProp(value, "teamPortalCorporateId")) {
                    return { success: false, reason: `[#/components/schemas/TeamSubscription/teamPortalCorporateId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'teamPortalCorporateId'.` };
                  }
                  const parsed_teamPortalCorporateId = ((): ParserResult<number> => {
                    return ((value: unknown): ParserResult<number> => {
                      if (typeof value === "number") {
                        return { success: true, value: value };
                      }
                      return { success: false, reason: `[#/components/schemas/TeamSubscription/teamPortalCorporateId]: '${value}' expected to be of type number.` };
                    })(value["teamPortalCorporateId"]);
                  })();
                  if (!parsed_teamPortalCorporateId.success) {
                    return { success: false, reason: parsed_teamPortalCorporateId.reason };
                  }
                  if (!hasProp(value, "teamPortalUrl")) {
                    return { success: false, reason: `[#/components/schemas/TeamSubscription/teamPortalUrl]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'teamPortalUrl'.` };
                  }
                  const parsed_teamPortalUrl = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/TeamSubscription/teamPortalUrl]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["teamPortalUrl"]);
                  })();
                  if (!parsed_teamPortalUrl.success) {
                    return { success: false, reason: parsed_teamPortalUrl.reason };
                  }
                  if (!hasProp(value, "teamPortalUsername")) {
                    return { success: false, reason: `[#/components/schemas/TeamSubscription/teamPortalUsername]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'teamPortalUsername'.` };
                  }
                  const parsed_teamPortalUsername = ((): ParserResult<string> => {
                    return ((value: unknown): ParserResult<string> => {
                      if (typeof value !== "string") {
                        return { success: false, reason: `[#/components/schemas/TeamSubscription/teamPortalUsername]: '${value}' expected to be of type string.` };
                      }
                      return { success: true, value: value };
                    })(value["teamPortalUsername"]);
                  })();
                  if (!parsed_teamPortalUsername.success) {
                    return { success: false, reason: parsed_teamPortalUsername.reason };
                  }
                  return { success: true, value: { teamPortalCorporateId: parsed_teamPortalCorporateId.value, teamPortalUrl: parsed_teamPortalUrl.value, teamPortalUsername: parsed_teamPortalUsername.value } };
                })(value);
              })(value["teamSubscription"]);
            })();
            if (!parsed_teamSubscription.success) {
              return { success: false, reason: parsed_teamSubscription.reason };
            }
            return {
              success: true,
              value: {
                actionStatus: parsed_actionStatus.value,
                customerId: parsed_customerId.value,
                editSubscriptionUrl: parsed_editSubscriptionUrl.value,
                endDate: parsed_endDate.value,
                giftSubscription: parsed_giftSubscription.value,
                isCredited: parsed_isCredited.value,
                isExpired: parsed_isExpired.value,
                isLoss: parsed_isLoss.value,
                isMobileSubscription: parsed_isMobileSubscription.value,
                isPaid: parsed_isPaid.value,
                isTeamSubscription: parsed_isTeamSubscription.value,
                manualRenewalUrl: parsed_manualRenewalUrl.value,
                numberOfTransactions: parsed_numberOfTransactions.value,
                product: parsed_product.value,
                productId: parsed_productId.value,
                quantity: parsed_quantity.value,
                randomKey: parsed_randomKey.value,
                startDate: parsed_startDate.value,
                studentVerification: parsed_studentVerification.value,
                subscriptionId: parsed_subscriptionId.value,
                subscriptionPayment: parsed_subscriptionPayment.value,
                subscriptionStatus: parsed_subscriptionStatus.value,
                teamSubscription: parsed_teamSubscription.value,
              },
            };
          })(value);
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/CustomerAdminSubscriptionsForm/subscriptions]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["subscriptions"]);
    })();
    if (!parsed_subscriptions.success) {
      return { success: false, reason: parsed_subscriptions.reason };
    }
    return {
      success: true,
      value: {
        customerId: parsed_customerId.value,
        customerLanguageId: parsed_customerLanguageId.value,
        customerName: parsed_customerName.value,
        customerRandomCode: parsed_customerRandomCode.value,
        emailHistory: parsed_emailHistory.value,
        hasStudentSubscription: parsed_hasStudentSubscription.value,
        studentPreverification: parsed_studentPreverification.value,
        subscriptions: parsed_subscriptions.value,
      },
    };
  })(parseJsonWithNumbersAsBigint(str));
}
